import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';
import moment from 'moment';
import { bindActionCreators } from 'redux';

import { RaisedButton } from 'material-ui';

import { getSendEmail } from 'actions/sender';

class SingleSenderPage extends React.Component {
    UNSAFE_componentWillMount() {
        this.props.getSendEmail(this.props.routeParams.id);
    }

    render() {
        const { sender: { _id, html, subject, to, category, updateAt, addedAt, status } } = this.props;

        return (
            <div id='sender-single-page' className='table-page'>
                <div className='container'>
                    <h2>Email</h2>

                    <div className='paper-block margin-10'>
                        <div className='row'>
                            <div className='col-xs-2 middle-xs' style={{display: 'flex'}}>
                                <RaisedButton
                                    label='back to the list'
                                    containerElement={
                                        <Link to={`/sender/list`} />
                                    }
                                    primary
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-xs-6">
                            <div className='paper-block margin-10'>
                                <span className='name-block small-name absolute'>info</span>

                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>id</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { _id }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>subject</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { subject }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>to</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { to }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>category</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { category }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>updateAt</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { moment(updateAt).format('MM.DD.YYYY') }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>addedAt</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { moment(addedAt).format('MM.DD.YYYY') }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>updateAt</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { updateAt }
                                    </div>
                                </div>
                                <hr />
                                <div className="row">
                                    <div className="col-xs-2">
                                        <b>addedAt</b>
                                    </div>
                                    <div className="col-xs-10">
                                        { addedAt }
                                    </div>
                                </div>
                            </div>

                            <div className='paper-block margin-10'>
                                <span className='name-block small-name absolute'>status</span>
                                <pre>
                            {
                                JSON.stringify(this.props.sender.status, null, ' ')
                            }
                            </pre>
                            </div>
                        </div>
                        <div className="col-xs-6">
                            <div className='paper-block margin-10'>
                                <span className='name-block small-name absolute'>original</span>
                                <iframe srcDoc={html} sandbox style={{ overflow: 'auto', border: 'none', width: '100%', height: '100vh' }} ref="iframe" frameBorder="0" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ sender }) => {
        return {
            sender,
        };
    },
    dispatch => bindActionCreators({
            getSendEmail,
        },
        dispatch),
)(SingleSenderPage);



// WEBPACK FOOTER //
// ./app/components/Letters/Sender/Single.jsx